define(function (require) {
	const tpl = require('../saved_searches_template/t_itv_saved_searches.hbs');
	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'li',
		attributes: {
			'role': 'listitem'
		},
		className: function() {
			var className = 'saved-search-item';
			if(this.model.get('isDefault')) {
				className += " default-saved-search";
			} else {
				className += " collapsible-content expanded";
			}
			return className;
		},
		ui: {
			applySearch: '.on-search'
		},
		events: {
			'click @ui.applySearch': 'applySavedSearch'
		},
		initialize: function () {

		},
		onShow:function(){

		},
		applySavedSearch: function () {
			const currentHash = window.location.hash.toLowerCase();
			const currentUrl = window.location.href.split('#')[0];
			let baseUrl;

			if (currentHash.startsWith('#tasks')) {
				baseUrl = `${currentUrl}#tasks/`;
			} else {
				// Default to projects if not task
				baseUrl = `${currentUrl}#projects/`;
			}

			const savedSearchData = this.model.get('searchData');
			
			// Construct the new URL
			const newUrl = `${baseUrl}${savedSearchData}`;

			if (window.location.href === newUrl) {
				// Manually re-apply logic instead of relying on navigation
				this.triggerMethod('apply:filter', savedSearchData);
				return;
			}

			// Redirect to the new URL
			window.location.href = newUrl;
		},
		templateHelpers: function() {
			return {
				searchName: this.model.get('name'),
				isDefault: this.model.get('isDefault')
			}
		},
	});
});
